import { Fragment } from "react";
import { SERVICE_ALIAS } from "@constants/service";
import { selectL10N } from "@features/ui/UiSlice";
import { useAppSelector } from "@hooks/defineRtkTypedHook";
import { useOption } from "@hooks/useOption";


export const NoData = () => {
    const { serviceAlias } = useOption();
    const l10n = useAppSelector(selectL10N);

    return <div className="nodata-wrap">
        <div className={`nodata-content ${serviceAlias}`}>
            {
                serviceAlias !== SERVICE_ALIAS.LINEAGEM ?
                <div className="nodata-content-character">
                    <figure></figure>
                </div> : <Fragment />
            }
            <div className="nodata-content-article">
                <h1 className="nodata-content-title">{ l10n?.template?.noSearchResult }</h1>
                <ul className="nodata-content-summary">
                    <li>{ l10n?.template?.checkKeyword }</li>
                    <li>{ l10n?.template?.inputSpace }</li>
                </ul>
            </div>
        </div>
    </div>;
};